import { Injectable } from '@angular/core';
import { PowerLimitationData } from '@store';
import { Observable } from 'rxjs';
import { ClientService } from '../../client.service';
import { PowerLimitationHistoryPayload } from './power-limitation-history.model';

@Injectable()
export class PowerLimitationHistoryApi {
  private readonly endPointPrefix = 'iot/v1/analytics-api';
  private readonly version = 'v0';

  constructor(private clientService: ClientService) {}

  /**
   * Gets power limitation history log
   * @param body
   * @param version
   */
  getPowerLimitation(
    body: PowerLimitationHistoryPayload,
    version: string = this.version
  ): Observable<PowerLimitationData> {
    const endpoint = `${this.endPointPrefix}/dataLake/hems/${version}/limitations`;

    return this.clientService.post(endpoint, body);
  }
}
